import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'
import _imports_1 from '../assets/images/phone.png'
import _imports_2 from '../assets/images/add-img-1.png'
import _imports_3 from '../assets/images/position-icon.png'
import _imports_4 from '../assets/images/add-img-2.png'
import _imports_5 from '../assets/images/add-img-3.png'
import _imports_6 from '../assets/images/add-img-4.png'
import _imports_7 from '../assets/images/contact-icon-1.png'
import _imports_8 from '../assets/images/contact-icon-3.png'
import _imports_9 from '../assets/images/contact-icon-4.png'
import _imports_10 from '../assets/images/menu-icon.png'
import _imports_11 from '../assets/images/closed.png'
import _imports_12 from '../assets/images/arro.png'
import _imports_13 from '../assets/images/mobile-contect.jpg'


const _withScopeId = n => (_pushScopeId("data-v-357e678a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "menu-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-tab" }, [
  /*#__PURE__*/_createElementVNode("span", null, "解决方案")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "刷脸&刷掌支付")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "机器人3D视觉")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3D刷脸门锁门禁")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3D体积视频")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-con" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-tab" }, [
    /*#__PURE__*/_createElementVNode("span", null, "产品中心")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-con" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-tab" }, [
    /*#__PURE__*/_createElementVNode("span", null, "技术支持")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-tab" }, [
  /*#__PURE__*/_createElementVNode("span", null, "关于我们")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "公司介绍")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "新闻中心")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "menu-list" }, [
  /*#__PURE__*/_createElementVNode("span", null, "安思疆文化")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "phone"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系我们", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "contact-main"
}
const _hoisted_20 = { class: "closed" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "联系我们", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-con" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contact-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: "",
      class: "city-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "city-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "name" }, "深圳"),
      /*#__PURE__*/_createElementVNode("p", { class: "address" }, [
        /*#__PURE__*/_createTextVNode(" 深圳市南山区"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("留仙大道3370号南山智园崇文园区3号楼2201-02 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "",
      class: "position-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contact-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "",
      class: "city-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "city-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "name" }, "上海"),
      /*#__PURE__*/_createElementVNode("p", { class: "address" }, [
        /*#__PURE__*/_createTextVNode(" 上海市浦东新区"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("东方路710号汤臣金融大厦1110室 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "",
      class: "position-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contact-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: "",
      class: "city-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "city-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "name" }, "南京"),
      /*#__PURE__*/_createElementVNode("p", { class: "address" }, [
        /*#__PURE__*/_createTextVNode("南京市雨花台区"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("软件谷楚翘城5幢601室")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "",
      class: "position-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "contact-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: "",
      class: "city-img"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "city-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "name" }, "美国"),
      /*#__PURE__*/_createElementVNode("p", { class: "address" }, [
        /*#__PURE__*/_createTextVNode(" 974 E Riversong Dr.Eagle，"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("ID 83616 USA ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "",
      class: "position-icon"
    })
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "email-con" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "email-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: "",
      class: "email-icon"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "add-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "email-title" }, "商业合作"),
      /*#__PURE__*/_createElementVNode("p", { class: "email-add" }, "sales@angstrong.com")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "email-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: "",
      class: "email-icon"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "add-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "email-title" }, "企业总机"),
      /*#__PURE__*/_createElementVNode("p", { class: "email-add" }, "0755-86568667")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "email-list" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_9,
      alt: "",
      class: "email-icon"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "add-con" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "email-title" }, "销售热线"),
      /*#__PURE__*/_createElementVNode("p", { class: "email-add" }, "0755-86968872")
    ])
  ])
], -1))
const _hoisted_24 = { class: "mobileCon" }
const _hoisted_25 = { class: "topCon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "logo"
}, null, -1))
const _hoisted_27 = { class: "contectTab" }
const _hoisted_28 = {
  key: 0,
  class: "main"
}
const _hoisted_29 = {
  key: 0,
  class: "menuCon"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解决方案", -1))
const _hoisted_31 = {
  key: 0,
  class: "childrenCon"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品中心", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "技术支持", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关于我们", -1))
const _hoisted_37 = {
  key: 1,
  class: "childrenCon"
}
const _hoisted_38 = {
  key: 1,
  class: "contectCon"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.windowWidth >= 800)
      ? (_openBlock(), _createBlock(_component_el_affix, {
          key: 0,
          "z-index": 200
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_router_link, {
                  to: { name: 'home' },
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSubmit('TopBar-logo')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "menu-con",
                    onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mouseOver())),
                    onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mouseLeave()))
                  }, [
                    _hoisted_5,
                    _createElementVNode("ul", {
                      class: _normalizeClass(["menu-list-con", _ctx.tabTagOne == true ? 'menu-active' : ''])
                    }, [
                      _createVNode(_component_router_link, {
                        to: { name: 'PaymentPage' },
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSubmit('TopBar-PaymentPage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'RobotPage' },
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSubmit('TopBar-RobotPage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'LockPage' },
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSubmit('TopBar-LockPage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'MeasurePage' },
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSubmit('TopBar-MeasurePage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ], 2)
                  ], 32),
                  _createVNode(_component_router_link, {
                    to: { name: 'ProductMainPage' },
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSubmit('TopBar-ProductMainPage')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { name: 'ServicePage' },
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSubmit('TopBar-ServicePage')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: "menu-con",
                    onMouseenter: _cache[12] || (_cache[12] = ($event: any) => (_ctx.mouseOverTwo())),
                    onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mouseLeaveTwo()))
                  }, [
                    _hoisted_12,
                    _createElementVNode("ul", {
                      class: _normalizeClass(["menu-list-con", _ctx.tabTagTwo == true ? 'menu-active-two' : ''])
                    }, [
                      _createVNode(_component_router_link, {
                        to: { name: 'IntroducePage' },
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSubmit('TopBar-IntroducePage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'NewsPage' },
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSubmit('TopBar-NewsPage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'JoinPage' },
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSubmit('TopBar-JoinPage')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ], 2)
                  ], 32)
                ]),
                _createElementVNode("div", {
                  class: "contact",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contactTag = true), _ctx.handleSubmit('TopBar-ontactPop')))
                }, _hoisted_18),
                (_ctx.contactTag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_el_icon, {
                          color: "#FFFFFF",
                          size: "18px",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.contactTag = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CloseBold)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.windowWidth < 800)
      ? (_openBlock(), _createBlock(_component_el_affix, {
          key: 1,
          "z-index": 200
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_ctx.mobileTag != 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "menuIcon",
                      src: _imports_10,
                      alt: "",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mobileTag == 0 ? ((_ctx.mobileTag = 1), (_ctx.menuTag = 0)) : ''))
                    }))
                  : _createCommentVNode("", true),
                (_ctx.mobileTag == 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "menuIcon",
                      src: _imports_11,
                      alt: "",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.mobileTag = 0))
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'home' },
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSubmit('TopBar-logo')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.mobileTag != 2)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.mobileTag == 0 ? (_ctx.mobileTag = 2) : ''))
                      }, "联系我们"))
                    : _createCommentVNode("", true),
                  (_ctx.mobileTag == 2)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.mobileTag = 0))
                      }, "收起弹窗"))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.mobileTag)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_ctx.mobileTag == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", {
                            class: "menuList",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.menuTag != 1 ? (_ctx.menuTag = 1) : (_ctx.menuTag = 0)))
                          }, [
                            _hoisted_30,
                            _createElementVNode("img", {
                              class: _normalizeClass(_ctx.menuTag == 1 ? 'menuActive' : ''),
                              src: _imports_12,
                              alt: ""
                            }, null, 2)
                          ]),
                          (_ctx.menuTag == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'PaymentPage' },
                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleSubmit('TopBar-PaymentPage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 1 ? 'menuPick' : ''])
                                    }, " 刷脸&刷掌支付 ", 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_router_link, {
                                  to: { name: 'RobotPage' },
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSubmit('TopBar-RobotPage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 2 ? 'menuPick' : ''])
                                    }, " 机器人3D视觉 ", 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_router_link, {
                                  to: { name: 'LockPage' },
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleSubmit('TopBar-LockPage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 3 ? 'menuPick' : ''])
                                    }, " 3D刷脸门锁门禁 ", 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_router_link, {
                                  to: { name: 'MeasurePage' },
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleSubmit('TopBar-MeasurePage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 4 ? 'menuPick' : ''])
                                    }, " 3D体积视频 ", 2)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_router_link, {
                            to: { name: 'ProductMainPage' },
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSubmit('TopBar-ProductMainPage')))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menuList", _ctx.urlTag == 5 ? 'menuPick' : ''])
                              }, _hoisted_33, 2)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, {
                            to: { name: 'ServicePage' },
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleSubmit('TopBar-ServicePage')))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menuList", _ctx.urlTag == 6 ? 'menuPick' : ''])
                              }, _hoisted_35, 2)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", {
                            class: "menuList",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.menuTag != 2 ? (_ctx.menuTag = 2) : (_ctx.menuTag = 0)))
                          }, [
                            _hoisted_36,
                            _createElementVNode("img", {
                              class: _normalizeClass(_ctx.menuTag == 2 ? 'menuActive' : ''),
                              src: _imports_12,
                              alt: ""
                            }, null, 2)
                          ]),
                          (_ctx.menuTag == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'IntroducePage' },
                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleSubmit('TopBar-IntroducePage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 7 ? 'menuPick' : ''])
                                    }, " 公司介绍 ", 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_router_link, {
                                  to: { name: 'NewsPage' },
                                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleSubmit('TopBar-NewsPage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 8 ? 'menuPick' : ''])
                                    }, " 新闻中心 ", 2)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_router_link, {
                                  to: { name: 'JoinPage' },
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleSubmit('TopBar-JoinPage')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["childrenList", _ctx.urlTag == 9 ? 'menuPick' : ''])
                                    }, " 安思疆文化 ", 2)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.mobileTag == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                      : _createCommentVNode("", true),
                    (_ctx.mobileTag)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "mask",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.mobileTag = 0))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}